import {Component, Input, OnInit, ViewChildren} from '@angular/core';
import {RotationOptionComponent} from "../../components/itemOptions/rotation-option/rotation-option.component";

@Component({
  selector: 'app-rotation-option',
  templateUrl: './rotation-option.component.html',
  styleUrls: ['./rotation-option.component.scss']
})
export class RotationOptionComponent21 extends RotationOptionComponent{
  private degrees = 0.5;
  public isVisible = false;
  get isRotatingNow(){
    return this.rotateService.isRotating;
  }
  isActiveNumber(degrees){
    return this.degrees === parseFloat(degrees);
  }
  setActiveDegrees(val){
    this.degrees = parseFloat(val);
    this.cd.detectChanges();
  }

  changeRotationWithDirection(isRight){
    (isRight) ? this.changeRotation(this.degrees) : this.changeRotation(-1*this.degrees);
    this.cd.detectChanges();
  }

  toggleNumbersVisibility(){
    this.setNumbersVisibility(!this.isVisible);
  }

  private setNumbersVisibility(flag){
    this.isVisible = flag;
  }
}
